export enum CAST_VOLUME_CONTROLLER {
    VOLUME_SLIDER = 'volume_slider',
}
